import React from 'react';
import { Outlet } from 'react-router-dom';
import RHSidebar from '../components/common/RHSidebar';

export default function RHLayout() {
    return (
        <div className="min-h-screen bg-gray-100">
            <RHSidebar />
            <div className="lg:ml-64">
                <Outlet />
            </div>
        </div>
    );
}